import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { invalidFieldsSelector } from 'reduxModules/forms/paymentMethod/selectors'
import { cardFieldsSummary } from './cardFields'
import './CardFieldsAlert.css'

// Shown next to the submit button: the card fields sit far above it, so a
// failed submit must say what to fix where the customer is looking.
export const CardFieldsAlert = ({ invalidFields }) => {
  const message = cardFieldsSummary(invalidFields)
  if (!message) return null
  return (
    <p className="card-fields-alert" role="alert">
      {message}
    </p>
  )
}

CardFieldsAlert.propTypes = {
  invalidFields: PropTypes.arrayOf(PropTypes.string)
}

CardFieldsAlert.defaultProps = {
  invalidFields: []
}

export default connect((state) => ({
  invalidFields: invalidFieldsSelector(state)
}))(CardFieldsAlert)
